(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["coupon-offers"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-tc-coupon-root]:not([data-tc-initialized])');

    roots.forEach((root) => {
      root.dataset.tcInitialized = 'true';

      const modal = root.querySelector('[data-modal]');
      const dialog = root.querySelector('.tc-coupon-offers__dialog');
      const openButton = root.querySelector('[data-modal-open]');
      const closeButtons = root.querySelectorAll('[data-modal-close]');
      const copyButtons = root.querySelectorAll('[data-copy-code]');
      const toast = root.querySelector('[data-toast]');
      const toastText = root.querySelector('[data-toast-text]');

      let previousFocus = null;
      let toastTimer = null;

      const showToast = (message) => {
        if (!toast) return;

        if (toastText) toastText.textContent = message;
        toast.classList.add('is-visible');

        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(() => {
          toast.classList.remove('is-visible');
        }, 1800);
      };

      const fallbackCopy = (text) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        const copied = document.execCommand('copy');
        textarea.remove();

        if (!copied) throw new Error('Copy failed');
      };

      copyButtons.forEach((button) => {
        button.addEventListener('click', async () => {
          const code = button.dataset.copyCode || '';
          const label = button.querySelector('[data-copy-label]');
          const defaultLabel = button.dataset.defaultLabel || 'Copy Code';
          const successLabel = button.dataset.successLabel || 'Copied!';

          if (!code || button.disabled) return;

          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(code);
            } else {
              fallbackCopy(code);
            }

            if (label) label.textContent = successLabel;
            showToast(`${successLabel} ${code}`);

            window.setTimeout(() => {
              if (label) label.textContent = defaultLabel;
            }, 1800);
          } catch (error) {
            showToast('Unable to copy. Please copy manually.');
          }
        });
      });

      const openModal = () => {
        if (!modal) return;

        previousFocus = document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tc-coupon-offers-open');

        if (openButton) openButton.setAttribute('aria-expanded', 'true');

        window.setTimeout(() => dialog?.focus(), 30);
      };

      const closeModal = () => {
        if (!modal) return;

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('tc-coupon-offers-open');

        if (openButton) openButton.setAttribute('aria-expanded', 'false');

        previousFocus?.focus?.();
      };

      openButton?.addEventListener('click', openModal);
      closeButtons.forEach((button) => button.addEventListener('click', closeModal));

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal?.classList.contains('is-open')) {
          closeModal();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
